export default __webpack_public_path__ + "static/media/not-found.6a7ea9d4.png";